module.exports = __webpack_public_path__ + "pg.svg?9806ef36eddcfcaa19e5f2ddc501d77c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pg.svg
// module id = 909
// module chunks = 27